export default __webpack_public_path__ + "static/business-mobile-bc7a7ee6a54ee353dc4fe4515c98e185.webp";